@if (is_loading) {
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
}


<div style="margin: 0px;">
  @if (myForm) {
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" novalidate>

      <div [hidden]="is_loading">
        <mat-card style="width: 400px; margin-top: 20px; margin-left: 20px;">


          <mat-card-header>
            <h2>Campaign</h2>
          </mat-card-header>

          <mat-card-content>

            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>Campaign Name:</mat-label>
              <input matInput type="text" placeholder="e.g. foo" (focus)="onFocus()" formControlName="name">
              <mat-error style="font-size: 12px">Valid name required</mat-error>
            </mat-form-field>

            <div style="margin-top: 15px; width: 100%">
              <mat-slide-toggle formControlName="status" (change)="onFocus()">
                {{ myForm.get('status')?.value === true ? 'Active' : 'Paused' }}
              </mat-slide-toggle>
            </div>

            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>Daily Frequency Cap:</mat-label>
              <input matInput type="number" placeholder="1" (focus)="onFocus()" formControlName="frequency_cap_daily">
              <mat-error style="font-size: 12px">Alpha, no spaces, and lowercase only</mat-error>
            </mat-form-field>

            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>Weekly Frequency Cap:</mat-label>
              <input matInput type="number" placeholder="1" (focus)="onFocus()" formControlName="frequency_cap_weekly">
              <mat-error style="font-size: 12px">Alpha, no spaces, and lowercase only</mat-error>
            </mat-form-field>

            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>Total Frequency Cap:</mat-label>
              <input matInput type="number" placeholder="1" (focus)="onFocus()" formControlName="frequency_cap_total">
              <mat-error style="font-size: 12px">Alpha, no spaces, and lowercase only</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill"  style="margin-top: 15px; width: 100%">
              <mat-label>Recency Cap (hours)</mat-label>
              <mat-select formControlName="recency_cap_in_hours">
                @for (hour of hoursOptions; track hour) {
                  <mat-option [value]="hour">{{ hour + 1 }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Start Date</mat-label>
              <input matInput [matDatepicker]="picker_start" formControlName="start_date">
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="picker_start"></mat-datepicker-toggle>
              <mat-datepicker #picker_start></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
              <mat-label>End Date</mat-label>
              <input matInput [matDatepicker]="picker_end" formControlName="end_date">
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="picker_end"></mat-datepicker-toggle>
              <mat-datepicker #picker_end></mat-datepicker>
            </mat-form-field>


            <div formGroupName="audience">

              <mat-list>
                <mat-list-item>Audience</mat-list-item>
                <mat-divider></mat-divider>
              </mat-list>
              <mat-form-field style="margin-top: 15px; width: 100%">
                <mat-label>Hour of Day:</mat-label>
                <input matInput type="text" placeholder="Midnight=0 9,10" (focus)="onFocus()" formControlName="hod">
                <mat-error style="font-size: 12px">Alpha, no spaces, and lowercase only</mat-error>
              </mat-form-field>

              <mat-form-field style="margin-top: 15px; width: 100%">
                <mat-label>Day of Week:</mat-label>
                <input matInput type="text" placeholder="Monday=0  1,2,3,4,5" (focus)="onFocus()" formControlName="dow">
                <mat-error style="font-size: 12px">Alpha, no spaces, and lowercase only</mat-error>
              </mat-form-field>

            </div>


          </mat-card-content>

          <mat-card-actions>
            <div class="flex-container" style="margin-top: 10px;">
              <button mat-raised-button color="primary" [disabled]="!myForm.valid || is_loading" type="submit"
                      style="margin: 15px">{{ submit_text }}
              </button>
              <button mat-raised-button color="accent" [disabled]="is_loading" type="button" (click)="backToCampaigns()"
                      style="margin: 15px">Cancel
              </button>
            </div>
          </mat-card-actions>


        </mat-card>

      </div>

    </form>
  }
</div>
